// extracted by mini-css-extract-plugin
export var button = "_11-1";
export var featuredLink = "_11-4";
export var spinner = "_11-2";
export var spinnerContainer = "_11-3";
export var text = "_11-0";